/**
 * Header chrome for sticky_header_type = on-scroll-up.
 *
 * Layout is CSS: announcement is pinned at top: 0, header is always
 * position:fixed at top: var(--amc-announcement-bar-height). The in-flow
 * slot is a spacer (subpages) or 0 (transparent homepage).
 *
 * This file only paints hide/show and overlay vs solid. It never toggles
 * position or writes inline top — that was the refresh/overlap bug.
 */
(function (window, document) {
  var HIDE_AFTER = 16;
  var SHOW_AFTER = 40;
  var SHOW_LOCK_MS = 220;
  var HIDE_LOCK_MS = 80;
  var SOLID_DELAY_MS = 400;

  var header;
  var container;
  var lastY = 0;
  var accDir = '';
  var accPx = 0;
  var showLockUntil = 0;
  var hideLockUntil = 0;
  var solidTimer = 0;
  var raf = 0;
  var ready = false;
  var hidden = false;
  var away = false;
  var maxY = 0;
  var headerH = 0;
  var annH = 0;
  var observersBound = false;

  function store() {
    try {
      return window.Alpine && Alpine.store && Alpine.store('xHeaderMenu');
    } catch (e) {
      return null;
    }
  }

  function now() {
    return window.performance && performance.now ? performance.now() : Date.now();
  }

  function measureScrollMax() {
    var viewH = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
    var docH = (document.documentElement && document.documentElement.scrollHeight)
      || (document.body && document.body.scrollHeight)
      || 0;
    maxY = docH - viewH;
    if (maxY < 0) maxY = 0;
  }

  function scrollY() {
    var y = window.pageYOffset;
    if (y == null) {
      y = (document.documentElement && document.documentElement.scrollTop)
        || (document.body && document.body.scrollTop)
        || 0;
    }
    if (y < 0) return 0;
    if (y > maxY) {
      measureScrollMax();
      if (y > maxY) return maxY;
    }
    return y;
  }

  function announcementEl() {
    var el = document.getElementById('x-announcement');
    if (!el || el.getAttribute('data-is-sticky') !== 'true') return null;
    return el;
  }

  function syncHeightHeader() {
    var root = document.documentElement;
    var overlayRest = false;
    var s = store();
    if (s && s.isTransparent && !away) overlayRest = true;
    /* Ignore 0-height reads (fonts / Alpine not painted yet). Writing 0px
       collapses the spacer and the page jumps when the real height lands. */
    var chrome = headerH > 8 ? headerH : 0;
    if (!hidden && !overlayRest) {
      if (chrome) root.style.setProperty('--height-header', (annH + chrome) + 'px');
      return;
    }
    root.style.setProperty('--height-header', annH + 'px');
  }

  function measure() {
    var ann = announcementEl();
    var content = document.getElementById('sticky-header-content');
    annH = ann ? ann.offsetHeight : 0;
    headerH = content ? content.offsetHeight : (header ? header.offsetHeight : 0);
    var root = document.documentElement;
    if (headerH > 8) {
      root.style.setProperty('--amc-header-chrome-height', headerH + 'px');
      root.style.setProperty('--top-header', headerH + 'px');
    }
    root.style.setProperty('--amc-announcement-bar-height', annH + 'px');
    root.style.setProperty('--announcement-height', annH + 'px');
    if (ann) {
      ann.classList.remove('amc-ann-up', 'amc-ann-animate');
    }
    measureScrollMax();
    syncHeightHeader();
  }

  function pastHero() {
    var hero = document.querySelector('.amc-hero-slideshow');
    if (!hero) return scrollY() > (window.innerHeight || 0) * 0.85;
    return hero.getBoundingClientRect().bottom <= 96;
  }

  function restCeiling() {
    return headerH > 8 ? headerH : 8;
  }

  function atRest(y) {
    return y <= restCeiling();
  }

  function menuBlocksHide() {
    var s = store();
    if (!s) return false;
    return !!(s.overlay || s.openHamburgerMenu || s.isMenuOpen);
  }

  function cartOpen() {
    try {
      return !!(window.Alpine && Alpine.store && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').open);
    } catch (e) {
      return false;
    }
  }

  function clearSolidTimer() {
    if (solidTimer) {
      clearTimeout(solidTimer);
      solidTimer = 0;
    }
  }

  function paint(y) {
    var s = store();
    var rest = atRest(y) && !hidden;
    away = !rest;
    if (!s) {
      syncHeightHeader();
      return;
    }
    s.isSticky = away;
    s.scrollDir = hidden ? 'down' : 'up';
    clearSolidTimer();

    if (!s.isTransparent) {
      s.chromeSolid = true;
      s.showLogoTransparent = false;
      syncHeightHeader();
      return;
    }

    if (rest || !pastHero()) {
      s.chromeSolid = false;
      s.showLogoTransparent = true;
      syncHeightHeader();
      return;
    }

    s.chromeSolid = false;
    s.showLogoTransparent = true;
    solidTimer = setTimeout(function () {
      solidTimer = 0;
      if (hidden || !pastHero()) return;
      s.chromeSolid = true;
      s.showLogoTransparent = false;
      syncHeightHeader();
    }, SOLID_DELAY_MS);
    syncHeightHeader();
  }

  function setHidden(next) {
    if (!header || hidden === next) return;
    hidden = next;
    if (next) {
      header.classList.add('header-up');
    } else {
      header.classList.remove('header-up', 'opacity-0');
    }
  }

  function tick() {
    if (!header) return;
    var y = scrollY();
    var delta = y - lastY;
    lastY = y;
    var t = now();

    if (atRest(y) || menuBlocksHide() || cartOpen()) {
      accDir = '';
      accPx = 0;
      setHidden(false);
      paint(y);
      return;
    }

    if (!delta) {
      paint(y);
      return;
    }

    var dir = delta > 0 ? 'down' : 'up';
    if (dir !== accDir) {
      accDir = dir;
      accPx = 0;
    }
    accPx += Math.abs(delta);

    if (dir === 'down' && accPx >= HIDE_AFTER && !hidden) {
      if (t < hideLockUntil) return;
      setHidden(true);
      showLockUntil = t + SHOW_LOCK_MS;
      accPx = 0;
      paint(y);
    } else if (dir === 'up' && accPx >= SHOW_AFTER && hidden) {
      if (t < showLockUntil) return;
      setHidden(false);
      hideLockUntil = t + HIDE_LOCK_MS;
      accPx = 0;
      paint(y);
    }
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      tick();
    });
  }

  function bind() {
    if (observersBound) return;
    observersBound = true;
    var opts = false;
    try {
      var probe = Object.defineProperty({}, 'passive', {
        get: function () {
          opts = { passive: true };
        }
      });
      window.addEventListener('__amc_p', null, probe);
      window.removeEventListener('__amc_p', null, probe);
    } catch (e) {}
    if (window.addEventListener) {
      window.addEventListener('scroll', onScroll, opts);
      window.addEventListener('resize', function () {
        measure();
      });
    } else if (window.attachEvent) {
      window.attachEvent('onscroll', onScroll);
      window.attachEvent('onresize', measure);
    }
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        measure();
      });
      var ann = announcementEl();
      var content = document.getElementById('sticky-header-content');
      if (ann) ro.observe(ann);
      if (content) ro.observe(content);
    }
  }

  function init() {
    header = document.getElementById('sticky-header');
    container = document.getElementById('x-header-container');
    if (!header || !container) return;
    if (container.getAttribute('data-amc-scroll-up') !== 'true') return;
    header.classList.add('on-scroll-up-animation');
    header.classList.remove('sticky-header');
    header.style.top = '';
    measure();
    lastY = scrollY();
    if (!ready) {
      ready = true;
      bind();
    }
    tick();
  }

  window.AmcHeaderChrome = {
    onScroll: onScroll,
    engageHidden: function () {
      onScroll();
    },
    release: function () {
      setHidden(false);
      paint(scrollY());
    },
    sync: function () {
      measure();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('alpine:initialized', function () {
    if (!ready) {
      init();
      return;
    }
    measure();
    paint(scrollY());
  });
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})(window, document);
